import { Autocomplete, FormControl, FormHelperText, TextField } from "@mui/material"
import { IAdvertiser } from "advertiser/model"
import { translate } from "app/language/service"
import { IRootState } from "app/model"
import { Field, FieldProps } from "formik"
import React from "react"
import { connect } from "react-redux"

interface ISelectOrCreateAdvertiserFieldProps {
  disabled?: boolean
  fieldName?: string
  value: string | number | null
  error: string | undefined
}

interface ISelectOrCreateAdvertiserFieldConnectProps {
  advertisers: IAdvertiser[]
}

const SelectOrCreateAdvertiserFieldFn = React.memo(
  ({
    disabled,
    fieldName,
    value,
    error,
    advertisers
  }: ISelectOrCreateAdvertiserFieldProps & ISelectOrCreateAdvertiserFieldConnectProps): JSX.Element => {
    let advertiser: IAdvertiser | null = null
    if (typeof value === "number") {
      advertiser = advertisers.find(a => a.id === value)
    }
    fieldName = fieldName ? fieldName : "advertiserNameOrId"
    return (
      <Field name={fieldName}>
        {({ form: { touched, setFieldValue, setFieldTouched } }: FieldProps) => {
          const hasError = (touched as any)[fieldName as string] ? error !== undefined && error !== "" : false
          return (
            <FormControl error={hasError}>
              <Autocomplete
                sx={{ "& input": { fontSize: ".8rem", pr: "1.8rem !important" } }}
                size="small"
                disabled={disabled}
                id="select-or-create-advertiser"
                options={advertisers}
                getOptionLabel={option => (typeof option === "string" ? option : option.name || "-")}
                value={advertiser}
                freeSolo
                onChange={(_event, newValue) => {
                  if (typeof newValue === "object") {
                    setFieldValue(fieldName as string, (newValue as IAdvertiser).id)
                    return
                  }
                  setFieldValue(fieldName as string, newValue)
                }}
                onBlur={() => setFieldTouched(fieldName as string, true)}
                inputValue={advertiser ? advertiser.name : typeof value === "string" ? value : ""}
                onInputChange={(_event, newInputValue) => setFieldValue(fieldName as string, newInputValue)}
                filterSelectedOptions
                renderOption={(props, option) => (
                  <li {...props} key={`listItem-${option.id}-${option.id}`}>
                    {option.name || "-"}
                  </li>
                )}
                renderInput={params => (
                  <TextField {...params} required error={hasError} label={translate("label.advertiser")} />
                )}
              />
              {hasError && <FormHelperText id={`${fieldName}-error`}>{error}</FormHelperText>}
            </FormControl>
          )
        }}
      </Field>
    )
  }
)

export const SelectOrCreateAdvertiserField = connect(
  (state: IRootState): ISelectOrCreateAdvertiserFieldConnectProps => ({
    advertisers: state.advertiser.advertisers
  })
)(SelectOrCreateAdvertiserFieldFn)
